export default __webpack_public_path__ + "static/media/SWT1180.34I-43205_-25832_0.91719b84.jpg";